export default __webpack_public_path__ + "static/media/ActiveTradeIcon.870cbd05.svg";